import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards } from "swiper/modules";
import { useSelector, useDispatch } from "react-redux";
import {
  AddNewCertificate,
  AddNewService,
  fetchAllData,
} from "../../../redux/slices/mainDataSlice";
import { toast } from "react-toastify";

export default function ServiceAdd({ serviceAdd, setServiceAdd }) {
  const [name, setName] = useState(``);
  const [desc, setDesc] = useState(``);
  const dispatch = useDispatch();

  const saveNewService = () => {
    dispatch(AddNewService({ name, desc }));
    setDesc("");
    setName("");
    toast.info("Adding Service...", { autoClose: false });
    setServiceAdd(false);
  };
  return (
    serviceAdd && (
      <div className="service-add-action" data-aos="fade-in">
        <div
          className="content-layout"
          onClick={() => setServiceAdd(false)}
        ></div>
        <div className="container ">
          <div className="title">اضافه خدمه جديده</div>

          <div className="text">
            <input
              type="text"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <textarea
              type="text"
              placeholder="Description"
              value={desc}
              onChange={(e) => setDesc(e.target.value)}
            />
          </div>
          <div className="add-btn" onClick={() => saveNewService()}>
            اضافه
          </div>
        </div>
      </div>
    )
  );
}
